<template>
    <loading :active.sync="isLoading"
            :background-color="bgColor"
            :can-cancel="canCancel"
            :color="color"
            :height="height"
            :is-full-page="fullPage"
            :loader="loader"
            :on-cancel="cancel"
            :width="width">
        <h3 v-if="useSlot">Loading ...</h3>
    </loading>

</template>

<script>
/**
 * loding component
 *
 * @author minkyoung.park@emcast.com
 */
// Import component
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
    data() {
        return {
            isLoading: false,
            fullPage: true,
            canCancel: true,
            useSlot: false,
            loader: 'spinner',
            color: '#263238',
            bgColor: 'var(--ModalDim)',
            height: 80,
            width: 80,
            timeout: 3000, //ms
        }
    },
    components: {
        Loading
    },

    methods: {
        show(payload, isCancel) {
          const options = {
            fullPage: !payload,
            width: payload ? 30 : 80,
            height: payload ? 30 : 80,
            isLoading: true
          };
          Object.assign(this, options);
        },

        hide() {
            this.isLoading = false
        },

        cancel() {
          this.canCancel = false;
        }
    }
}
</script>

<style>
.vld-overlay {
    z-index: 9999 !important;
}
</style>
